export const DEPRECATED_BLOCKS = [
  "AI_GENERATED_TEXT",
  "STRING_JOINING",
  "STRING_JOINING_TXT",
  "CARD_IMG_FROM_BLOCK",
  "BOT_WELCOME_MESSAGE",
  "AIIMAGE_GENERATE_IMAGE_IN_CARD",
  "AIIMAGE_GENERATE_IMAGE_IN_CARD_NEW",
  "RAGAI_BUTTON",
  "RAGAI_BUTTON_TEXT",
  "RAGAI_BUTTON_OUTPUT",
  "RAGAI_BUTTON_OUTPUT_IF",
  "RAGAI_BUTTON_TEXT_2",
  "RAGAI_BUTTON_2",
  "WAITFOR_NEXTIDLE",
  "WAITFOR_INITIDLE",
  "WAITFOR_SCORMINITED",
  "WAITFOR_INITVARS",
  "WAITFOR_EVENT",
  "WAITFOR_SECONDS",
  "WAITFOR_MINUTES",
  "SKILL_ENABLECHILD",
  "SKILL_DISABLECHILD",
  "SKILL_ACTIONS",
  "BOT_CONTROLS",
  "OVERLAY_ACTIONS",
  "OVERLAY_TEXT_BTN",
  "OVERLAY_TEXT",
  "TOASTR_PRECONF",
  "STAGE_ACTIONS",
  "STAGE_HIDE_SHOW",
  "STAGE_DELETE",
  "DOC_SEARCH",
  "SKILL_FOR_NEXT_RUN",
  "SKILL_JOINING",
  "EVENTS_ON",
  "toastr_SUCCESS",
  "toastr_ERROR",
  "toastr_INFO",
  "toastr_WARNING",
  "toastr_options",
  "IFTHEN_COUNTER",
  "GLOBAL_VAR",
  "EVENT_ALL",
  "EVENT_ALL_RAW",
  "EVENT_TRIGGER",
  "EVENT_DISABLE",
  "EVENT_ENABLE",
  "EVENT_OFF",
  "AITEXT_OPENAI_CHATCOMPLESION",
  "AITEXT_OPENAI_CHATCOMPLETIONJSON",
  "BOT_BYPASS_THREAD",
  "OVERLAY_UPLOAD_IMAGE_ANALYSE_WITH_IMAGE",
  "OVERLAY_UPLOAD_TXT_EASY",
  "BLOCK_STACK_WEBHOOK",
  "BLOCK_STACK_DATABASE",
  "BLOCK_STACK_WENNDANN",
  "BLOCK_STACK_ONLINESOURCE",
  "BLOCK_STACK_OFFLINEWEBSITE",
  "BLOCK_STACK_FUSIONVIEW",
  "BLOCK_STACK_PROJECTSECRET",
  "KEYVAL_SET",
  "KEYVAL_UNIQUE",
  "KEYVAL_GET",
  "KEYVAL_GET_COLLECTION_VALUES",
  "KEYVAL_GET_COLLECTION_TEXT",
  "KEYVAL_GET_COLLECTION_TEXT_V2",
  "PROJECTKEYVAL_SET_V2",
  "PROJECTKEYVAL_UNIQUE_V2",
  "PROJECTKEYVAL_GET_V2",
  "PROJECTKEYVAL_GET_COLLECTION_VALUES_V2",
  "PROJECTKEYVAL_GET_COLLECTION_TEXT_V2",
  "PROJECTKEYVAL_SET",
  "PROJECTKEYVAL_UNIQUE",
  "PROJECTKEYVAL_GET",
  "PROJECTKEYVAL_GET_COLLECTION_VALUES",
  "PROJECTKEYVAL_GET_COLLECTION_TEXT",
  "RAGAI_DOWNLOAD_TEMPLATE",
  "MAIL_SEND_WEBHOOK",
  "MAIL_ENVELOPE",
  "webhook_options",
  "webhook_custom_options",
  "custom_option_item",
  "CARD_BUTTONS",
  "SEND_PROMPT_TXT",
  "STAGE_LSITBTN",
  "DIALOGRECORDER_actions",
  "DIALOGRECORDER_OVERRIDE_USER_NAMES",
  "DIALOGRECORDER_getDialogHtml",
  "DIALOGRECORDER_actions_NEW",
  "DIALOGRECORDER_ID_DROPDOWN",
  "RAG_IF_2",
  "OVERLAY_PROMPT"
] as const satisfies readonly string[];

export const DEPRECATED_BLOCKS_SET: ReadonlySet<string> = new Set(DEPRECATED_BLOCKS);

/**
 * Veraltete Blöcke mit eindeutigem Nachfolger in der aktuellen Toolbox.
 * Abgesichert durch server/src/_tests/BlocklyCatalog.spec.ts (Nachfolger existiert und ist nicht veraltet).
 */
export const DEPRECATED_BLOCK_REPLACEMENTS: Readonly<Partial<Record<(typeof DEPRECATED_BLOCKS)[number], string>>> = {
  CARD_IMG_FROM_BLOCK: "CARD_IMG_FROM_BLOCK_NEW",
  RAGAI_BUTTON_OUTPUT: "RAGAI_BUTTON_OUTPUT_NEW",
  WAITFOR_SECONDS: "WAITFOR_SECONDS_NEW",
  SKILL_FOR_NEXT_RUN: "SKILL_FOR_NEXT_RUN_NEW",
  EVENTS_ON: "EVENTS_ON_NEW",
  EVENT_TRIGGER: "EVENT_TRIGGER_NEW",
  KEYVAL_SET: "KEYVAL_SET_V2",
  KEYVAL_UNIQUE: "KEYVAL_UNIQUE_V2",
  KEYVAL_GET: "KEYVAL_GET_V2",
  KEYVAL_GET_COLLECTION_VALUES: "KEYVAL_GET_COLLECTION_VALUES_V2",
  CARD_BUTTONS: "CARD_BUTTONS_NEW",
  SEND_PROMPT_TXT: "SEND_PROMPT_TXT_NEW",
  OVERLAY_PROMPT: "OVERLAY_PROMPT_NEW",
};

export function getDeprecatedBlockReplacement(type: string): string | undefined {
  return (DEPRECATED_BLOCK_REPLACEMENTS as Record<string, string | undefined>)[type];
}

export function isDeprecatedBlock(type: string): boolean {
  return DEPRECATED_BLOCKS_SET.has(type);
}
